import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Outlet } from 'react-router-dom'

import { DataError } from '../ErrorBoundary'

const Main: React.FC = () => {
  return (
    <>
      <main className="main flex flex-1 flex-col">
        <ErrorBoundary fallback={<DataError />}>
          <Outlet />
        </ErrorBoundary>
      </main>
    </>
  )
}

export default Main
